import style from './style.css';
import { connect, useDispatch } from 'react-redux';
import { Component } from 'preact';
import MuiInput from '../../material-ui/muiInput';
import { getNumericValue } from '../../../utils/stringOperations';
import RequestButton from '../../requestButton';
import ntbAction from '../../../actions/ntbAction';
import actionType from '../../../actions/ntbAction/actionType';
import VerifyOtpCheck from './otpInput';
import { tracker, UserActionType } from '../../../tracking';
import BenefitsSection from '../overlayEmiDetails/benefitsSection';
import withBaseComponent from '../../../HOC/withBaseComponent';

type Props = {
  uiComponents: Array<BicContentType>,
  pageKey: string,
  bicAction: Function,
  showShowLenderList: boolean,
  getLenderList: Array<LenderDetails>,
  ntbDetails: Object,
  apiState: boolean,
  message: string,
  userStatus: string,
  showEligibilityModal: boolean,
  showNonApprovedModal: boolean,
  shouldShowOTPScreen: boolean,
};

type State = {
  mobileNumber: number,
};

class OverlayEligibiltyCheck extends Component<Props, State> {
  state = {
    mobileNumber: '',
  };

  pageKey = 'pv_bic_check_eligibility_overlay';

  logos = [
    {
      icon: 'https://iccdn.in/img/hdfc-logo-icon-v2.png',
      lenderImage: 'https://iccdn.in/lenders/hdfc-branding-logo-v1.png',
      lenderId: '501',
    },
  ];

  render() {
    return (
      <div className={style.overlayEligibiltyCheckContainer}>
        <div className={style.checkEligibilityContainer}>
          <div className={style.headerContainer}>
            <div className={style.headerText}>Check Your Eligibility Now</div>
          </div>
          {this.props.shouldShowOTPScreen ? (
            <VerifyOtpCheck
              pageKey={this.pageKey}
              ntbAction={this.props.ntbAction}
              mobileNumber={this.state.mobileNumber}
              resendOTP={() => {
                tracker.trackUserInteraction(
                  UserActionType.CLICK,
                  'bic_resend _otp_cta',
                  this.pageKey,
                );
                return this.props.ntbAction(actionType.sendOTP, {
                  mobile: this.state.mobileNumber,
                });
              }}
            />
          ) : (
            <div className={style.mobileNumberContainer}>
              <div className={style.loginContainer}>
                <div
                  className={` greyInputBox ${
                    style.inputContainer
                  } overlayMobileNumberInput`}>
                  <MuiInput
                    pageKey={this.pageKey}
                    className={style.inputBox}
                    inputPlaceholder='Enter your mobile number'
                    inputType='tel'
                    elementName='bic_enter_mobile'
                    maxLength={10}
                    minLength={10}
                    inputValue={this.state.mobileNumber}
                    autoFocus={false}
                    onChange={(e) => {
                      this.setState({
                        mobileNumber: getNumericValue(e.target.value),
                      });
                    }}
                  />
                </div>
                <div className={style.otpSubmitButton}>
                  <RequestButton
                    buttonDisabled={this.state.mobileNumber.length !== 10}
                    buttonId='send_otp_button'
                    pageKey={this.pageKey}
                    buttonWrapperClass={style.submitButton}
                    elementName='bic_send_otp_cta'
                    buttonText='Verify'
                    buttonOnClick={() => {
                      return this.props.ntbAction(actionType.sendOTP, {
                        mobile: this.state.mobileNumber,
                      });
                    }}
                  />
                </div>
              </div>
              <div className={style.innerSubText}>
                An OTP will be sent to this number
              </div>
            </div>
          )}
          <div className={style.advantagesWrapper}>
            <div className={style.preApprovedContainer}>
              <div className={style.preApprovedText}>
                <span class='bold-text'>4.5+ crore</span> preapproved users
              </div>
              <img
                className={style.userImage}
                src='https://iccdn.in/img/ic_user-count-image.png'
                alt='user group image'
              />
            </div>
            <div className={style.lendersContainer}>
              <div className={style.lendersText}>
                <span class='bold-text'>7+ trusted lenders</span> available
              </div>
              {this.logos.map((logo) => (
                <img
                  src={logo.icon}
                  className={style.lenderIcon}
                  alt='lender-logo'
                />
              ))}
            </div>
          </div>
        </div>
        <BenefitsSection />
      </div>
    );
  }
}

const mapStateToProps = ({ ntbConfig }) => {
  const {
    getLenderList,
    apiState,
    showShowLenderList,
    ntbDetails,
    message,
    userStatus,
    showEligibilityModal,
    showNonApprovedModal,
    shouldShowOTPScreen,
  } = ntbConfig;

  return {
    apiState,
    showShowLenderList,
    getLenderList,
    ntbDetails,
    message,
    userStatus,
    showEligibilityModal,
    showNonApprovedModal,

    shouldShowOTPScreen,
  };
};

export default connect(
  mapStateToProps,
  { ntbAction },
)(withBaseComponent(OverlayEligibiltyCheck));



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/overlayEligibiltyCheck/index.js